module.exports = __webpack_public_path__ + "static/media/Team 34 - Interchange Explorers.19d899a5.png";